module.exports = __webpack_public_path__ + "img/6c5883a.jpg";